import { Injectable, signal, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

interface ToastEntry {
  message: string;
  id: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly transloco = inject(TranslocoService);
  private _counter = 0;

  readonly current = signal<ToastEntry | null>(null);

  show(key: string, duration = 3000): void {
    const message = this.transloco.translate(key);
    const id = ++this._counter;
    this.current.set({ message, id });
    setTimeout(() => {
      this.current.update((t) => (t?.id === id ? null : t));
    }, duration);
  }
}
